export const textOfBrandedVideo =
  'Download the HD Video file or Copy the direct link to your Video only';
export const textOfUnBrandedVideo =
  'Download the HD Video file or Copy the direct link to your Video only';
export const textOfExtraVideo =
  'Download the HD Video file or Copy the direct link to your Video only';
